module.exports = __webpack_public_path__ + "static/media/evaluate-helpful.ba071603.svg";